import React, {Fragment, useMemo} from 'react';
import {Form, FormField, Submit, Edit, Popup} from 'components';
import {noop, over, get, useNamedSelector, useFocusPopup, useField} from 'helpers';

export function CategoriesDropdown(props) {
  const [ { value }, , { setValue } ] = useField(props);
  const popup = useFocusPopup(Categories, {
    ...props,
    value,
    setValue,
    className: 'adjacent'
  });
  const categories = useNamedSelector('notes.categoriesByName');
  return (
    <FormField label="Category" value={value} Wrapper="div" {...popup}>
      <b>{ get(categories, `${value}.name`, value) }</b>
    </FormField>
  );
}

function Categories({ popup, value, setValue }) {
  const NewCategory = useMemo(() => () => (
    <Form className="compact" onSubmit={over(popup.close, ({ name }) => setValue(name))} delay>
      <Edit required autoFocus name="name" placeholder="Enter new category.." />
      <Submit icon="check" />
    </Form>
  ), []);
  return (
    <Fragment>
      <Popup.Menu className="is-small">
        { useNamedSelector('notes.categories').map(category =>
          <Popup.Menu.Item key={category.id} pressed={category.name == value} icon={'category-'.concat(category.predefined ? category.id : 'custom')} onClick={() => setValue(category.name)}>
            { category.name || 'Untitled' }
          </Popup.Menu.Item>
        ) }
      </Popup.Menu>
      <Popup.Menu.Separator />
      <Popup.Menu onClick={noop}>
        <Popup.Menu.AdvanceItem icon="plus" Component={NewCategory}>New Category</Popup.Menu.AdvanceItem>
      </Popup.Menu>
    </Fragment>
  );
}
